import { API } from '../../api';
import { INFORM_DATA_MANAGER } from '../../data';

export default {
    namespaced: true,
    state: {
        totalUnreadNumber: 0,
        gotInformListData: false,
        totalInformList: [],
        totalInformData: {},
    },
    getters: {},
    mutations: {
    },
    actions: {
        getConfigTips({ state }) {
            API.getConfigTips({}, function(data) {
                console.log('获取提示数据成功:::::::', data)
                state.totalUnreadNumber = data.unread;
            })
        },
        getMsgList({ state }, params) {
            API.getMsgList({
                page: 1
            }, function(data) {
                console.log('获取通知消息列表成功:::::::', data)
                state.gotInformListData = true;
                state.totalInformData = data.total;
                var resultList = INFORM_DATA_MANAGER.getInformListByData(data.info);
                state.totalInformList = state.totalInformList.concat(resultList);
                    state.totalInformList = state.totalInformList.sort((a, b) => {a.unread - b.unread})
                    if(params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        updateMsgList({ state }, params) {
            var nowpage = parseInt(state.totalInformData.nowpage),
                totalpage = state.totalInformData.totalpage;
            if(nowpage < totalpage) {
                API.getMsgList({
                    page: nowpage+1
                }, function(data) {
                    state.totalInformData = data.total;
                    var resultList = INFORM_DATA_MANAGER.getInformListByData(data.info);
                    state.totalInformList = state.totalInformList.concat(resultList);
                    state.totalInformList = state.totalInformList.sort((a, b) => {a.unread - b.unread})
                })
            }
        },
        setMsgRead({ state }, informData) {
            API.setMsgRead({
                id: informData.id
            }, function(data) {
                if(data.ret) {
                    state.totalUnreadNumber = state.totalUnreadNumber - 1;
                    state.totalInformList = INFORM_DATA_MANAGER.updateInformListReadStatusByInformId(state.totalInformList, [informData.id.toString()]);
                }
            })
        },
        setAllMsgRead({ state }) {
            API.setMsgRead({
                id: '-1'
            }, function(data) {
                if(data.ret) {
                    state.totalUnreadNumber = 0;
                    state.totalInformList = INFORM_DATA_MANAGER.updateInformAllListReadStatusByInformId(state.totalInformList);
                }
            })
        },
        resetData({ state }) {
            state.gotInformListData = false;
            state.totalInformList = [];
            state.totalInformData = {};
        }
    }
}